<nav
        class="shadow navbar navbar-expand-lg py-1"
        [ngStyle]="{ 'background-color': backgroundColor }"
        *ngIf="userService.user() && userService.isAuthenticated() && userService.isActive()"
>
    <div class="navbar-left">
        <div class="page-indicator-icon d-flex">
            <a routerLink="/admin/dashboard" class="cursor-pointer">
                <i [ngClass]="[headerIcon, headerIconColor]" class="page-icon h2"></i>
            </a>
        </div>
        <div class="current-view">
            <div class="current-page">{{ headerTitle }}</div>
            <div
                    class="current-page-component"
                    [ngClass]="{ 'cursor-pointer': headerSubTitleClickable }"
                    (click)="selectWorkplace()"
            >
                {{ headerSubTitle }}
            </div>
        </div>
    </div>
    <div class="navbar-right">
        <div class="user-profile d-flex">
            <div class="user-image d-flex">
                <app-user-avatar></app-user-avatar>
            </div>
            <div class="user-details m-3">
                <div class="user-name">{{ userService.user()?.username }}</div>
                <div class="user-role">{{ userService.userrole() }}</div>
            </div>
        </div>
        <div class="logout">
            <a class="nav-link" routerLink="/logout" (click)="logout()">
                <i class="bi bi-box-arrow-right h2 logout-icon" alt="Logout Logo"></i>
            </a>
        </div>
    </div>
</nav>
